import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { composeValidators, validateEmail, validateIsfilled, getTimeZone, capitalize, optionSelectGenerator, extrapolateProp, formatOnlyNumberInput } from '../../libraries/utils';
import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';
import Terms from '../../components/customs/Terms';
import CheckboxInput from '../../components/forms/CheckboxInput';
import SelectInput from '../../components/forms/SelectInput';
// import DatepickerInput from '../../components/forms/DatepickerInput';
import { dateComponents } from '../../libraries/utils';
import companiesActions from '../../context/companies/actions';
import BirthDateInput from '../../components/forms/BirthDateInput';
import { zonedTimeToUtc } from 'date-fns-tz';
import logo from '../../assets/img/logo.png';
import actions from '../../context/settings/actions';
import Loader from '../../components/commons/Loader';


class SignupURL extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      signupData: {},
      firstClickTerms: true,
      showTerms: false,
      loading: true,
      company_name: '',
      activeSaveUser: false,
    }
  }
  
  async componentDidMount() {
    console.log('SIGNUP PAGE');
    const params = this.props.match.params;
    if (params.hash) {
    try {
      // Asumiendo que el hash contiene el unique_id encriptado
      const companyUniqueId = JSON.parse(atob(params.hash));
      this.setState({ companyUniqueId });
      await this.getSettings();
      await this.getCompany(companyUniqueId);
    } catch (error) {
      console.error('Error desencriptando URL:', error);
      // history.push(config.ROUTES.LOGIN);
    }
  }
    // if (params.hash) {
    //   await this.checkHash(params);
    //   this.getCompany();22222222212
    // }
  }
 
  checkHash = async (params) => {
    await this.props.onGetFromHash(params);
    const user = this.props.user;
    if (user.error) {
      history.push(config.ROUTES.LOGIN);
    } else {
      //if (user.item.status === "active") {
      //  setTimeout(()=>history.push(config.ROUTES.LOGIN), 5000)
      //  notify(capitalize(this.t('Este usuario ya está activo, inicia sesión.')))
      //} else {
        this.setState({ user: extrapolateProp(user.item, "json_data"), preRegistered: true });
      //}
    }
  };
  getSettings = async () => {
    const paramsHash = this.props.match.params;
    const unique_id = JSON.parse(atob(paramsHash.hash))
    // await this.props.onGetSettings();
    //http://localhost:8897/api/v1/settings?type=sharyco_settings&owner=4d954b2e-a694-4515-b2e4-d2ba1764269f&order_by=created_at&order_direction=DESC
    const params = {
      type: 'sharyco_settings',
      owner: unique_id,
      code: ["singup_global", "singup_global_pre_register"],
      // code: "singup_global_pre_register",
    }
    await this.props.getAllActions(params);
    const settings = this.props.settings;
    if (settings.error) {
      notify(this.t(settings.error))
    } else {
      if(settings.items.length){
        this.setState({ settings: settings.items },this.validateGlobalRegister(settings.items))
      }
    }
  }

  validateGlobalRegister = (settings) => {
// debugger
    const globalRegister = settings.find(s => s.code === 'singup_global');
    const save_without_pre_registration = settings.find(s => s.code === 'singup_global_pre_register');

    if(!save_without_pre_registration){
      this.setState({ save_without_pre_registration: false });
    }else{
      this.setState({ save_without_pre_registration:  (save_without_pre_registration.value == false || save_without_pre_registration.value === 'false')? false : true });
    }
    if(!globalRegister) return history.push(config.ROUTES.HOME);
    if(globalRegister.value == false || globalRegister.value === 'false') return history.push(config.ROUTES.HOME);


  }

  getCompany = async (uniqueId) => {
    console.log("GET COMPANY----", uniqueId);
    
    await this.props.onGetCompany(uniqueId);
    const { company } = this.props
    console.log("COMPANY", company);
    
    if (company.error) {
      notify(this.t(company.error))
    } else {
      if(company.item){
        this.setState({ company_name: company.item?.name })
      }
    }
    this.setState({ loading: false })
  }

  checkUserMail = async (email) => {
    await this.props.onGetUsers({email});
    const users = this.props.users;
    if (users.error) {
      //history.push(config.ROUTES.LOGIN);
    } else {
      if(users.items.length){
        this.setState({ user: extrapolateProp(users.items[0], "json_data"), preRegistered: true });
        console.log("CHECKHASH", extrapolateProp(users.items[0], "json_data"))
      }
    }
  };

  finalizeSignUp = async (data) => {
    data.id = this.state.user.id 

    await this.props.saveOrUpdate({
      id: this.state.user.id,
      phone: data.phone,
      birth_date: data.birth_date,
      unique_id: this.state.companyUniqueId,
      status: data.status || "new", 
      json_data: {
        first_name: data.first_name,
        last_name: data.last_name,
        gender: data.gender,
        labor_identification_code: data.labor_identification_code,
        identification: data.identification,
      }
    }, 'register');
    const user = this.props.user;
    this.setState({ submitting: false });
    if (user.error) {
      notify(this.t(user.error.message));
    } else {
      history.push({
        pathname: config.ROUTES.VERIFY.replace(':hash', this.props.user.item.hash),
        state: {
          preSignup: true
        }
      });
    }
  }

  onSubmit = async (values) => {
    this.setState({submitting: true, signupData: {...values}});
    
    const data = {
      ...values,
      time_zone: getTimeZone(),
      user_type: config.USER_TYPE.REGULAR,
      role: "",
      status: "new", 
      unique_id: this.state.companyUniqueId,
      // welcome_email: false,
      // verify_email: true,
      // invitation_email: false,
      // birth_date: values.birth_date.toISOString()
    }

    data.birth_date = new Date (dateComponents(values.birth_date)[3].dateOnly);
    // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // const utcDate = zonedTimeToUtc(data.birth_date, timeZone)
    // data.birth_date = utcDate

    if(!data.terms) return
    delete data.terms

    //data.birth_date = dateComponents(values.birth_date)[3].dateOnly;
    if(!this.state.user){
       await this.props.onGetUsers({email: data.email});
      const users = this.props.users;
      if (users.error) {
        notify(this.t(users.error));
        return;
      }
      if(users.items.length > 0){
        notify("No es posible registrarse con este email.");
        return;
      }

      await this.props.onRegister(data);
      const user = this.props.user;
      if (user.error) {
        if(user.error.code){
          if(user.error.code === 'REGISTER_ERROR_NOT_ACTIVE'){
            await this.checkUserMail(values.email);
            this.finalizeSignUp(data);
            return;
          }
        }
        this.setState({ submitting: false });
        notify(this.t(user.error.message));
      } else {
        //history.push(config.ROUTES.PASSWORD.replace(':hash', this.props.user.item.hash));
        history.push(
          config.ROUTES.VERIFY.replace(':hash', this.props.user.item.hash)
        );
      }
    } else {
      // Usuario encontrado - verificar si tiene ID para actualizar o crear nuevo
      if (this.state.user.id) {
        // Usuario existente con ID - actualizar
       data.status = values.status
        this.finalizeSignUp(data);
      } else {
        await this.props.onRegister(data);
        const user = this.props.user;
        this.setState({ submitting: false });
        if (user.error) {
          notify(this.t(user.error.message));
        } else {
          history.push(
            config.ROUTES.VERIFY.replace(':hash', this.props.user.item.hash)
          );
        }
      }
    }
  }

  onTerms = () => {
    history.push(config.ROUTES.TERMS);
  }

  onLogin = () => {
    history.push(config.ROUTES.LOGIN);
  }
  getSettings = async () => {
    const paramsHash = this.props.match.params;
    const unique_id = JSON.parse(atob(paramsHash.hash))
    // await this.props.onGetSettings();
    //http://localhost:8897/api/v1/settings?type=sharyco_settings&owner=4d954b2e-a694-4515-b2e4-d2ba1764269f&order_by=created_at&order_direction=DESC
    const params = {
      type: 'sharyco_settings',
      owner: unique_id,
      code: ["singup_global", "singup_global_pre_register"],
      // code: "singup_global_pre_register",
    }
    await this.props.getAllActions(params);
    const settings = this.props.settings;
    if (settings.error) {
      notify(this.t(settings.error))
    } else {
      if(settings.items){
        this.setState({ settings: settings.items },this.validateGlobalRegister(settings.items))
      }
    }
  }

  searchUser = async (values) => {
    if(!this.state.save_without_pre_registration) return;
    if (!values.email) {
      notify(this.t("Debes ingresar email o número de teléfono"));
      return;
    }
    
    this.setState({ submitting: true });

    try {
      const searchParams = { user_type: 'regular' };
      if (values.email) searchParams.email = values.email;

      await this.props.onFindExtendedUser(searchParams);
      const result = this.props.users;      
      
      if (result.items?.length > 0) {
        const foundUser = result.items[0];
        const perteneceAEstaEmpresa = foundUser.unique_id === this.state.companyUniqueId;

        if(!perteneceAEstaEmpresa){
          notify(this.t("Este usuario ya está registrado. Pertenece a otra organizacion."), 'ERROR');
          this.setState({ submitting: false });
          return;
        }
        // Verificar el status del usuario
        // if (foundUser.status === 'active') {
        //   notify(this.t("Este usuario ya está registrado. Por favor utiliza otro email o teléfono."), 'ERROR');
        //   this.setState({ submitting: false });
        //   return;
        // }
        
        const userData = {
          ...foundUser.json_data,
          id: foundUser.id,
          email: foundUser.email,
          phone: foundUser.phone,
          preRegistered: true,
          birth_date: foundUser.birth_date,
          status: foundUser.status,
        };

        this.setState({ user: userData, activeSaveUser: true });
        // notify(this.t("Usuario encontrado. Todos los datos han sido completados automáticamente."), 'SUCCESS');
      } else {
        this.setState({ user: null, activeSaveUser: false });
        notify(this.t("Usuario no encontrado. No puedes completar el registro."));
      }
    } catch (error) {
      console.error("Error in searchUser:", error);
      notify(this.t("Error al buscar usuario"));
    } 
    this.setState({ submitting: false });
  };
  isAdult = (date) => {
    const messajege = this.t("El campo es requerido");
    if (!date) return messajege;
  
    const today = new Date();
    const birthDate = new Date(date);
  
    let age = today.getFullYear() - birthDate.getFullYear();
  
    const m = today.getMonth() - birthDate.getMonth();
  
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    const isvalid = age >= 18; 
    return isvalid? undefined : this.t("Debes ser mayor de 18 años para registrarte");
  };
  render() {
    const { showTerms, firstClickTerms, company_name, loading } = this.state;
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))
    const today = new Date(2010, 9, 10);
    const genders = [
      { value: "man", label: capitalize(this.t("man")) },
      { value: "woman", label: capitalize(this.t("woman")) },
      { value: "other", label: capitalize(this.t("Other"))},
      { value: "not_say", label: capitalize(this.t("Prefiero no decir"))},
    ];

    const customHeaderStyle = {
      backgroundColor: 'transparent', // Cambia el color de fondo
      // Otros estilos personalizados
  };
    if (this.props.settings.loading || this.props.company.loading || loading) {
      return (
        <>
          <Loader />
        </>
      );
    }
    return (
      <>
        <img src={logo} className='h-12 mx-auto mt-2'/>
        <div className={'fixed top-0 left-0 flex items-center w-full h-full bg-[#00000066] z-20' + (showTerms ? '' : ' hidden')}>
          <div className='h-3/4 bg-base-300 w-full rounded-t-3xl p-8'>
            <h2 className='text-center font-medium'>{capitalize(this.t('Términos y condiciones'))}</h2>
            <div className='mt-4 h-[90%] overflow-y-scroll flex flex-col'>
            <Terms className={"flex-1 text-justify"}/>
              <div className='flex gap-3'>
                <Button title={capitalize(this.t('acepto'))} className='mt-3 btn-secondary btn-sm'
                  onClick={()=>this.setState({ showTerms: false }, this.form.mutators.setTerms)}
                />
                <Button title={capitalize(this.t('no acepto'))} className='mt-3 btn-primary btn-sm'
                  onClick={()=>this.setState({ showTerms: false })}
                />
              </div>
            </div>
          </div>
        </div>
        <ToastContainer/>
        <h2 className="text-primary text-center mb-5 mt-5">{this.t("Register")}</h2>
        <div className='card bg-primary-focus p-3 mx-6 mb-4 text-center lg:max-w-lg lg:mx-auto'>
          {company_name &&
            <>
              <p className='text-white text-base'>Registrate en el grupo de</p>
              <p className='text-yellow-400 font-bold text-lg'>{company_name}</p>
            </>
          }
        </div>
        <Form
          initialValues={this.state.user || {}}
          onSubmit={this.onSubmit}
          mutators={{setTerms: (args, state, utils) => {
            utils.changeValue(state, 'terms', () => true)
          }}}
        >
          {({ handleSubmit, form, submitting, pristine, values, invalid }) => {
            this.form = form;
            const handleKeyDown = (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                this.searchUser(values);
              }
            };
          return <>
            <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} className="w-full max-w-lg mx-auto px-4">
           {this.state.save_without_pre_registration &&(
             <>
              <div className="w-full mb-3 md:mb-0">
                  <Field name="email" component={TextInput} placeholder={this.t("Email")} label={this.t("Email")} validate={composeValidators(required, email)} parse={ v => v.trim() }
                    inputClassName='rounded-xl outline outline-1 outline-[#2A818933]'/>
                </div>
                <div className='w-full my-3'>
                  <Button 
                    className="btn-secondary btn-block"
                    title={this.t("Buscar usuario")}
                    onClick={() => this.searchUser(values)}
                    disabled={(!values.email && !values.phone) || this.state.submitting}
                  />
                </div>
             </>
           )}
           {
             !this.state.save_without_pre_registration && (
              <div className="w-full mb-3 md:mb-0">
              <Field name="email" component={TextInput} placeholder={this.t("Email")} label={this.t("Email")} validate={composeValidators(required, email)} parse={ v => v.trim() }
                inputClassName='rounded-xl outline outline-1 outline-[#2A818933]'/>
            </div>
             )
           }
              <div className="w-full mb-3 md:mb-0">
                <Field name="identification" component={TextInput} placeholder={this.t("Número de Identificación Personal (DNI)")} label={this.t("Número de Identificación Personal (DNI)")} validate={required}
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]'/> 
              </div>
              <div className="w-full mb-3 md:mb-0">
                <Field name="first_name" component={TextInput} placeholder={this.t("First name")} label={this.t("First name")} validate={required}
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]' />
              </div>
              <div className="w-full mb-3 md:mb-0">
                <Field name="last_name" component={TextInput} placeholder={this.t("Last name")} label={this.t("Last name")} validate={required}
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]' />
              </div>
              {/* <div className="w-full mb-3 md:mb-0">
                <Field name="labor_identification_code" component={TextInput} placeholder={this.t("CUIL")} label={this.t("CUIL")}
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]'/> 
              </div> */}

              {/*fixme: ¿pidieron fecha de nacimiento?*/}
              {/*fixme: traer el componente de birthdate input de innos (hecho con selects)*/}
              <div className="w-full flex gap-4 items-center mb-3 md:mb-0">
                {/* <Field name="birth_date" component={DatepickerInput} placeholder="01/01/1999" validate={required} showYear 
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]' /> */}
                <Field 
                  name="birth_date" 
                  component={BirthDateInput}
                  label={this.t("Fecha de nacimiento")}
                  className='w-full'
                  //validar que sea mayor de edad
                  validate={this.isAdult}
                  // initialValue={today}
                  // defaultValue={today}
                />
              </div>

              <div className="w-full mb-3 md:mb-0">
                <Field name="phone" component={TextInput} placeholder={this.t("Phone number")} label={this.t("Phone number")} validate={required}
                  inputClassName='rounded-xl outline outline-1 outline-[#2A818933]' parse={v => formatOnlyNumberInput(v,20)} />
              </div>
              <div className="w-full mb-3 md:mb-0">
               <Field name="gender" component={SelectInput} placeholder={this.t("Género")} label={this.t("Género")} empty={capitalize(this.t("Seleccione su género"))} validate={required}
                  options={genders} inputClassName='rounded-xl outline outline-1 outline-[#2A818933]' selectClassName="w-full"/>
              </div>


              <div className="w-full mb-3 md:mb-0" onClick={()=>{
                  if(firstClickTerms) {
                    this.setState({ firstClickTerms: false, showTerms: true })
                  }    
                }}
              >
                <Field name="terms" component={CheckboxInput} label={this.t("I accept terms and conditions")}
                  validate={required}
                  className={firstClickTerms ? 'pointer-events-none' : ''}
                  labelClassName='justify-start items-center gap-2'
                  checkboxClassName="checkbox-secondary rounded-full border-none bg-white"
                  type="checkbox"
                />
              </div>
              <div className="w-full">
                <Button
                type='submit'
                  className="btn-secondary btn-block"
                  title={this.t("Next")}
                  // onClick={handleSubmit}
                  disabled={(Boolean(this.state.save_without_pre_registration) == false? false:!this.state.activeSaveUser )}
                />
              </div>
            </form>
          </>
          }}
        </Form>
        <div className="w-full px-3 mt-5">
          <Button
            className="btn-link btn-block underline text-primary"
            title={this.t("Términos y condiciones")}
            onClick={()=>this.setState({ showTerms: true })}
          />
        </div>
        <div className="mt-2 p-2 flex justify-center items-center">
          <p className="label-text text-center mr-1">{this.t("¿Ya tienes cuenta??")}</p>
          <Button
            className="btn-link mb-0 underline text-primary"
            title={this.t("Login with your user")}
            onClick={(this.onLogin)}
          />
        </div>
      </>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.current,
    users: state.users.list,
    company: state.companies.current,
    settings: state.settings.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRegister: (params) => dispatch(userActions.saveOrUpdate(params, 'register')),
    onGetFromHash: (params) => dispatch(userActions.getFromHash(params)),
    onGetUsers: (params) => dispatch(userActions.getAll(params)),
    onFindExtendedUser: (params) => dispatch(userActions.findExtended(params)),
    onGetCompany: (params) => dispatch(companiesActions.get(params)),
    saveOrUpdate: (params, action) => dispatch(userActions.saveOrUpdate(params, action)),
    getAllActions: (params) => dispatch(actions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(SignupURL));
